export default __webpack_public_path__ + "static/media/Verified_Icon.7d397430.svg";